module.exports = __webpack_public_path__ + "static/media/img_dance02.9215a71c.png";